import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get_all_users } from "../../redux/actions/userAction";
import EditUser from "./EditUser";
import UserDetails from "./UserDetails";


const UserListing = () => {
  const dispatch = useDispatch();

  const {
    users = [],
    meta = {},
    isLoading = false,
  } = useSelector((state) => state.user || {});

  const [role, setRole] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  // modals / actions
  const [viewModal, setViewModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);


  useEffect(() => {
    dispatch(
      get_all_users({
        role,
        search,
        page,
        limit: 10,
      })
    );
  }, [dispatch, role, search, page]);

  const handleView = (user) => {
    setSelectedUser(user);
    setViewModal(true);
  };

  const handleEdit = (user) => {
    setSelectedUser(user);
    setEditModal(true);
  };


  const handleCloseModal = () => {
    setViewModal(false);
    setEditModal(false);
    setSelectedUser(null);
  };

  return (
    <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-5">
                <h2 className="mb-0">All Users</h2>
               
            </div>   

      {/* FILTERS */}
      <div className="row mb-3 g-2">
        <div className="col-md-3">
          <select
            className="form-select"
            value={role}
            onChange={(e) => {
              setPage(1);
              setRole(e.target.value);
            }}
          >
            <option value="">All Roles</option>
            <option value="tenant">Tenant</option>
            <option value="landlord">Landlord</option>
            {/* <option value="admin">Admin</option> */}
          </select>
        </div>

        <div className="col-md-5">
          <input
            type="text"
            className="form-control"
            placeholder="Search by name, email or mobile"
            value={search}
            onChange={(e) => {
              setPage(1);
              setSearch(e.target.value);
            }}
          />
        </div>
      </div>

      {/* TABLE */}
      <div className="row">
        <div className="col-12">
          <table className="table table-striped table-hover align-middle">
            <thead className="table-primary">
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile</th>
                <th>Role</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {/* LOADING */}
              {isLoading && (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    Loading users...
                  </td>
                </tr>
              )}

              {/* EMPTY */}
              {!isLoading && users.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    No users found
                  </td>
                </tr>
              )}

              {/* DATA */}
              {!isLoading &&
                users.map((user) => (
                  <tr key={user.uuid}>
                    <td>
                      <strong>
                        {user.first_name} {user.last_name}
                      </strong>
                    </td>

                    <td>{user.email}</td>
                    <td>{user.mobile_no || "-"}</td>

                    <td>
                      <span
                        className={`badge ${user.role === "tenant"
                            ? "bg-info"
                            : user.role === "landlord"
                              ? "bg-warning text-dark"
                              : "bg-danger"
                          }`}
                        style={{ minWidth: 80, display: 'inline-block', textAlign: 'center' }}
                      >
                        {/* {user.role} */}
                        {user.role.charAt(0).toUpperCase() + user.role.slice(1)}
                      </span>
                    </td>
                    {/* STATUS */}
                    <td>
                      <span
                        className={`badge ${user.status ? "bg-success" : "bg-danger"
                          }`}
                      >
                        {user.status ? "Active" : "Inactive"}
                      </span>
                    </td>


                    {/* ACTIONS */}
                    <td>
                      <button
                        className="btn btn-sm btn-info me-2 text-white"
                        onClick={() => handleView(user)}
                      >
                        <i className="bi bi-eye"></i> View
                      </button>

                      <button
                        className="btn btn-sm btn-warning me-2 text-white"
                        onClick={() => handleEdit(user)}
                      >
                        <i className="bi bi-pencil"></i> Edit
                      </button>

                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* PAGINATION */}
      {meta?.totalPages > 1 && (
        <div className="d-flex justify-content-center gap-2 mt-3">
          <button
            className="btn btn-outline-primary btn-sm"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          <span className="align-self-center">
            Page {page} of {meta.totalPages}
          </span>

          <button
            className="btn btn-outline-primary btn-sm"
            disabled={page === meta.totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}

      {editModal && (
        <EditUser
          userData={selectedUser}
          role={role}
          search={search}
          page={page}
          closeModal={handleCloseModal}
        />
      )}

      {/* VIEW MODAL (same as ProvinceListing) */}
      {viewModal && selectedUser && (
        <UserDetails
          selectedUser={selectedUser}
          handleCloseModal={handleCloseModal}
        />
      )}


    </div>
  );
};

export default UserListing;
